export default "__VITE_ASSET__BsApZ9Bo__";